import React from 'react';
export function SectionImage4() {
  return <section className="w-full" data-id="element-120">
      
    </section>;
}